import { writable } from 'svelte/store';
export default (()=>{
	const { subscribe, update } = writable([])
	return {
		subscribe,
		add:(slice)=>{
			update((slices)=> slices.concat(slice))
			setTimeout(()=>{ // remove first one after 3 seconds
				update((slices)=> slices.slice(1))
			},3000)
		}
	}
})()
